import { Grid, IconButton, Box, Dialog, DialogContent } from '@mui/material'
import { FaEye } from 'react-icons/fa'
import { MdRemoveCircle } from 'react-icons/md'
import { useState } from 'react'
import CardTable from '../../../../components/CardTable'
import FileUploader from '../../../../components/FileUploader'
import { getdoc } from '../../../../components/api'

const COLUNAS = ['Documento', '']

const ESTILO_COL = [
  { width: '70%', truncate: true },
  { width: '30%', textAlign: 'center' },
]

const mapear = (doc) => [doc.dsDocumento, '']

export const DocumentosPaciente = ({ onChange }) => {
  const [listaDocumentos, setListaDocumentos] = useState([])
  const [loadingArquivo, setLoadingArquivo] = useState(null)
  const [openDocumento, setOpenDocumento] = useState(false)
  const [urlDocumento, setUrlDocumento] = useState(null)

  const handleVisualizar = async (token) => {
    if (!token) return

    setLoadingArquivo(token)

    try {
      const res = await getdoc(token)
      const blob = await res.blob()

      const url = URL.createObjectURL(blob)

      setUrlDocumento(url)
      setOpenDocumento(true)
    } finally {
      setLoadingArquivo(null)
    }
  }

  const handleFecharDocumento = () => {
    if (urlDocumento) {
      URL.revokeObjectURL(urlDocumento)
    }

    setUrlDocumento(null)
    setOpenDocumento(false)
  }

  const handleRemover = (doc) => {
    const novos = listaDocumentos.filter(
      (d) => d.idDocumento !== doc.idDocumento,
    )
    setListaDocumentos(novos)
    onChange(
      novos.map(({ idDocumento, dsDocumento }) => [idDocumento, dsDocumento]),
    )
  }

  const handleUploadComplete = (data) => {
    const doc = data?.documento?.[0]
    if (!doc?.idDocumento) return
    const novos = [
      ...listaDocumentos,
      {
        idDocumento: doc.idDocumento,
        dsDocumento:
          doc.fileName ||
          doc.nmDocumento ||
          doc.dsDocumento ||
          `Documento ${listaDocumentos.length + 1}`,
        dsToken: doc.dsToken,
      },
    ]
    setListaDocumentos(novos)
    onChange(
      novos.map(({ idDocumento, dsDocumento }) => [idDocumento, dsDocumento]),
    )
  }

  const opcoesColuna = [
    {
      alias: 1,
      customJsx: ({ linhaOriginal }) => (
        <>
          <IconButton
            size="small"
            onClick={() => handleVisualizar(linhaOriginal.dsToken)}
          >
            <FaEye />
          </IconButton>
          <IconButton
            size="small"
            color="error"
            onClick={() => handleRemover(linhaOriginal)}
          >
            <MdRemoveCircle />
          </IconButton>
        </>
      ),
    },
  ]

  return (
    <Grid item xs={12}>
      {listaDocumentos?.length > 0 && (
        <>
          <Dialog
            open={openDocumento}
            onClose={handleFecharDocumento}
            maxWidth={false}
            PaperProps={{
              sx: {
                width: '90vw',
                height: '90vh',
                maxWidth: '90vw',
                maxHeight: '90vh',
              },
            }}
          >
            <DialogContent
              sx={{
                p: 0,
                overflow: 'hidden',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <img
                src={urlDocumento}
                alt="Documento"
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'contain',
                }}
              />
            </DialogContent>
          </Dialog>
          <CardTable
            titulo="Documentos do Atendimento"
            colunas={COLUNAS}
            estiloColunas={ESTILO_COL}
            dadosTabela={listaDocumentos}
            loadingToken={loadingArquivo}
            mapear={mapear}
            opcoesColuna={opcoesColuna}
            semBordas
          />
        </>
      )}

      <Box sx={{ mt: 2 }}>
        <FileUploader
          title="Anexar Documento"
          path="/documentos/"
          snPublico="N"
          onUploadComplete={handleUploadComplete}
        />
      </Box>
    </Grid>
  )
}
